export default "__VITE_ASSET__BpjeRA7H__"